import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { OverlayComponent } from '../components/overlay/overlay.component';

@Injectable({
  providedIn: 'root'
})
export class OverlayService {

  overlayRef: OverlayRef;

  constructor(private overlay: Overlay) { }

  open() {
    const config = new OverlayConfig({
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      hasBackdrop: true,
      backdropClass: 'dark-backdrop',
      panelClass: 'tm-file-preview-dialog-panel',
      scrollStrategy: this.overlay.scrollStrategies.block()
    });

    this.overlayRef = this.overlay.create(config);
    const componentPortal = new ComponentPortal(OverlayComponent);
    this.overlayRef.attach(componentPortal);
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }

}
